const config = {
  siteTitle: "Rokkey", // Site title.
  siteTitleShort: "Rokkey رُقي", // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: "Rokkey رُقي", // Alternative site title for SEO.
  siteLogo: "/logos/rokkey.jpg", // Logo used for SEO and manifest.
  siteUrl: "https://rokkey.com", // Domain of your website without pathPrefix.
  pathPrefix: "", // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription:
    "رُقي تساعد الشركات على تطوير أعمالها عبر الإنترنت وتوليد العملاء المحتملين من خلال خدمات تصميم المواقع والتسويق الالكتروني وإدارة وسائل التواصل الاجتماعي .", // Website description used for RSS feeds/meta description tag.
  siteRss: "/rss.xml", // Path to the RSS file.
  siteFBAppID: "576866762412926", // FB Application ID for using app insights
  googleAnalyticsID: "UA-57010463-1", // GA tracking ID.
  dateFromFormat: "YYYY-MM-DD", // Date format used in the frontmatter.
  dateFormat: "DD/MM/YYYY", // Date format for display.
  userName: "Ammar Jabakji", // Username to display in the author segment.
  userEmail: "info@rokkey.com", // Email used for RSS feed's author segment
  userTwitter: "gatsbyjs", // Optionally renders "Follow Me" in the Bio segment.
  userGitHub: "gatsbyjs", // Optionally renders "Follow Me" in the Bio segment.
  // gatsby_disqus_name: 'rokkey-com',
  userLocation: "North Pole, Earth", // User location to display in the author segment.
  userAvatar: "https://i.ibb.co/WPz9CNk/avatar.jpg", // User avatar to display in the author segment.
  userDescription: "Yeah, Welcome", // User description to display in the author segment.
  copyright: ` © ${new Date().getFullYear()} جميع الحقوق محفوظة rokkey.com رُقي.`, // Copyright string for the footer of the website and RSS feed.
  themeColor: "#0171b9", // Used for setting manifest and progress theme colors.
  backgroundColor: "#f7f7f7", // Used for setting manifest background color.
};

// Validate

// Make sure pathPrefix is empty if not needed
if (config.pathPrefix === "/") {
  config.pathPrefix = "";
} else {
  // Make sure pathPrefix only contains the first forward slash
  config.pathPrefix = `/${config.pathPrefix.replace(/^\/|\/$/g, "")}`;
}

// Make sure siteUrl doesn't have an ending forward slash
if (config.siteUrl.substr(-1) === "/")
  config.siteUrl = config.siteUrl.slice(0, -1);

// Make sure siteRss has a starting forward slash
// if (config.siteRss && config.siteRss[0] !== "/")
//   config.siteRss = `/${config.siteRss}`;

module.exports = config;
